<template>
    <div>
      <div class="social-share" :data-sites="['qzone', 'qq', 'weibo','wechat', 'douban']"></div>
    </div>
</template>

<script>

    export default {
        name: 'Test',
        components: {
        },
        data: function () {
        },
        filter: {},
        mounted() {
            // location.href = this.$route.query.url;
        },
        destroyed() {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// Test.vue?7dff7d32